<div class="mb-4">
  <span class="fw-bold"> Courbe de l'indice Insee : </span>
  <span>
    {{ tendencies.inseeGraph ? "Activé" : "Désactivé" }}
  </span>
</div>
<div class="mb-4">
  <span class="fw-bold"> Etude de marché : </span>
  <span>
    {{ tendencies.marketStudy ? "Activé" : "Désactivé" }}
  </span>
</div>


